import { Component, EventEmitter, Output } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { BaseTopAppBarComponent } from '../base-top-app-bar/base-top-app-bar.component';

/**
 * Admin-specific top app bar that extends the base toolbar.
 * Provides admin-specific styling and title.
 *
 * Based on Angular component inheritance guide:
 * https://angular.dev/guide/components/inheritance
 */
@Component({
  selector: 'app-admin-top-app-bar',
  imports: [MatButtonModule, MatIconModule, MatMenuModule, BaseTopAppBarComponent],
  template: `
    <div class="admin-theme">
      <app-base-top-app-bar
        [user$]="user$"
        [userRoleLabel]="'Administrator'"
        [hideAdminConsoleLink]="true"
        (signOut)="onSignOut()"
      >
        <!-- Hamburger menu (left of logo) -->
        <div slot="left-actions">
          <button
            mat-icon-button
            class="admin-menu-button"
            data-testid="admin-menu-button"
            (click)="onToggleDrawer()"
            aria-label="Toggle navigation menu"
          >
            <mat-icon>menu</mat-icon>
          </button>
        </div>

        <!-- Admin title content -->
        <span slot="content" class="admin-title" data-testid="admin-title">Administrative Console</span>

        <!-- Additional user menu items for admin -->
        <div slot="user-menu">
          <button mat-menu-item (click)="onSwitchAccount()">
            <mat-icon>swap_horiz</mat-icon>
            <span>Switch Account</span>
          </button>
        </div>
      </app-base-top-app-bar>
    </div>
  `,
  styleUrls: ['./admin-top-app-bar.component.scss'],
})
export class AdminTopAppBarComponent extends BaseTopAppBarComponent {
  @Output() toggleDrawer = new EventEmitter<void>();

  constructor() {
    super();
    this.userRoleLabel = 'Administrator';
  }

  onToggleDrawer(): void {
    this.toggleDrawer.emit();
  }

  onSwitchAccount(): void {
    this.switchAccount.emit();
  }
}
